/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Link, Stack } from "@mui/material";
import { FC } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

interface Props {
  /** Document name */
  name: string;
  /** Link URL */
  url: string;
}

/**
 * Component of document link
 * @param{Props} param0 Properties
 * @return{FC} Component
 */
export const DocumentLink: FC<Props> = ({ name, url }: Props) => {
  return (
    <Stack direction="row" spacing={2}>
      <Link href={url} color="inherit" download underline="hover">
        {name}
      </Link>
      <Link href={url} color="inherit" download>
        <OpenInNewIcon />
      </Link>
    </Stack>
  );
};
